import React from 'react';
import { useIntl } from 'react-intl';

export const intlHooks = {
  useFormatPrice(price: number | null, currency: string, minimumFractionDigits = 2) {
    const intl = useIntl();
    const formattedNumber = intl.formatNumber(
      price || 0,
      { style: 'currency', currency, minimumFractionDigits }
    );

    return React.useMemo(
      () => price !== null ? formattedNumber.replace(/\s+/g, '') : '',
      [price, formattedNumber],
    );
  },

  useFormatPriceToParts(price: number | null, currency: string) {
    const intl = useIntl();
    const parts = intl.formatNumberToParts(price || 0, { style: 'currency', currency });

    return React.useMemo(
      () => price !== null ? parts : [],
      [price, parts],
    );
  },

  useCurrencySymbol(currency: string) {
    const currencyToParts = intlHooks.useFormatPriceToParts(0, currency);

    return React.useMemo(() => {
      return currencyToParts.find(item => item.type === 'currency')?.value;
    }, [currencyToParts])
  },

  useDecimalSymbol(currency: string): string | null {
    const priceToParts = intlHooks.useFormatPriceToParts(0.1, currency);

    return React.useMemo(() => {
      return priceToParts.find(item => item.type === 'decimal')?.value ?? null;
    }, [priceToParts]);
  },

  useFormatNumberWithTwoDecimals(number: number, useGrouping = false) {
    const intl = useIntl();
    return intl.formatNumber(number, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      useGrouping,
    })
  },
};
